import { render, staticRenderFns } from "./sizeChart.vue?vue&type=template&id=0eab7c4e&scoped=true&"
import script from "./sizeChart.vue?vue&type=script&lang=js&"
export * from "./sizeChart.vue?vue&type=script&lang=js&"
import style0 from "./sizeChart.vue?vue&type=style&index=0&id=0eab7c4e&prod&lang=less&scoped=true&"
import style1 from "./sizeChart.vue?vue&type=style&index=1&id=0eab7c4e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eab7c4e",
  null
  
)

export default component.exports